import {
  BotIcon,
  CalendarClockIcon,
  DatabaseIcon,
  FileTextIcon,
  GitBranchIcon,
  InboxIcon,
  UserCheckIcon,
  type LucideIcon,
} from 'lucide-react'
import type { BuilderNodeKind } from '../../types/builder'

export const NODE_KINDS: Record<BuilderNodeKind, { label: string; icon: LucideIcon; tone: string }> = {
  intake: { label: 'Intake', icon: InboxIcon, tone: 'bg-[#1E2A44] text-[#9CC3FF]' },
  agent: { label: 'AI agent', icon: BotIcon, tone: 'bg-violet/20 text-violet-ink' },
  data: { label: 'Data source', icon: DatabaseIcon, tone: 'bg-[#16352E] text-[#7FE0C2]' },
  condition: { label: 'Condition', icon: GitBranchIcon, tone: 'bg-[#3A2E14] text-[#F5C76B]' },
  human: { label: 'Human approval', icon: UserCheckIcon, tone: 'bg-[#3A1E2B] text-[#F7A8C4]' },
  document: { label: 'Document', icon: FileTextIcon, tone: 'bg-[#25263A] text-[#C7C9F5]' },
  schedule: { label: 'Monitoring schedule', icon: CalendarClockIcon, tone: 'bg-[#1E3340] text-[#8FD3F0]' },
}
